import { useTranslation } from 'react-i18next';
import { useAllInfluencerCategoryOptions } from '@anytag/shared-hooks';
import { MultipleSelectorFieldProps, SelectorField } from '@anytag/shared-molecules';
import { InfluencersFilterFormKeys } from '../schemaTypes';

export const InfluencerCategoryField = (
  props: Omit<MultipleSelectorFieldProps<InfluencersFilterFormKeys>, 'name' | 'options' | 'multiple'>
) => {
  const { t } = useTranslation();
  const { allInfluencerCategoryOptions } = useAllInfluencerCategoryOptions();

  return (
    <SelectorField<InfluencersFilterFormKeys>
      name="categoryIds"
      title={t('Selector.Categories')}
      options={allInfluencerCategoryOptions}
      multiple
      {...props}
    />
  );
};
